import { defineComponent as _defineComponent } from 'vue'
import { getTravelAssistant } from '@/store';
import { useRouter } from 'vue-router/composables';
import Tab from './tab.vue';
import ThemeCard from '@/components/common/theme/theme-card.vue';
import SubwayTipDialog from '@/components/dialog/subway-tip-dialog.vue';
import { onBeforeMount, ref, computed } from 'vue';
import { ThemeList } from '@/types';
import { biClick } from '@tencent/fit-bi-sdk';
import { CustomEventKey } from '@/types/merchant';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['onHideModule'],
  setup(__props, { emit }) {



const router = useRouter();
// 地铁弹窗
const subwayTipDialog = ref<InstanceType<typeof SubwayTipDialog> | null>(null);

const themeLists = ref<ThemeList[]>([]);
const isReady = ref(false);

const serviceTabs = computed(() => themeLists.value.map(item => item.title));

const onClickTab = (tabIndex: number) => {
  biClick('service_list.tab|推荐服务列表Tab', { fservicetabid: themeLists.value[tabIndex].themeId });
};

// 处理自定义事件
function onClickCustomEvent(key: string) {
  // 地铁说明弹窗
  if (key === CustomEventKey.subway) {
    subwayTipDialog.value?.onShowDialog();
  }
  // 点击"全部"
  if (key === CustomEventKey.all) {
    router.push({ name: 'merchantDetail' });
  }
}

onBeforeMount(async () => {
  const serviceList = await getTravelAssistant();
  themeLists.value = (serviceList as ThemeList[]) || [];
  isReady.value = true;
});

return { __sfc: true,emit, router, subwayTipDialog, themeLists, isReady, serviceTabs, onClickTab, onClickCustomEvent, Tab, ThemeCard, SubwayTipDialog }
}

})